import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormArray } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';

import { SharedUtilsService } from 'src/app/core/services/shared-utils.service';
import { CommandeService } from 'src/app/core/services/commande.service';
import { ToastService } from 'src/app/core/services/toast.service';

import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';


@Component({
  selector: 'app-data-product',
  templateUrl: './data-product.component.html',
  styleUrl: './data-product.component.scss'
})
export class DataProductComponent {
  @Input() displayedColumns: { field: string; name: string; class: string }[] = [];
  @Input() dataSource: [] = [];
  @Input() parentForm!: FormGroup;
  @Input() isViewMode: boolean = false;

  @Output() articleAjoute = new EventEmitter<undefined>();
  @Output() articleModifie = new EventEmitter<number>();
  @Output() articleSupprime = new EventEmitter<number>();

  searchFilter = '';

  quickAddMode = false;

  prixCalcule: boolean = false;

  editingIndex: number | null = null;
  //editingArticle: any = {};
  loading = false;



  constructor(

    public dialog: MatDialog,
    public commandeService: CommandeService,
    public sharedUtilsService: SharedUtilsService,
    private toastService: ToastService,

  ) {


    
  }



  enableQuickAdd() {

    //this.quickAddMode = true;
    this.articleAjoute.emit();
    //this.resetNewArticle();
  }

  cancelQuickAdd() {
    this.quickAddMode = false;
    //this.resetNewArticle();
  }

  

  

  startEdit(index: number) {
    //this.editingIndex = index;
    this.articleModifie.emit(index);
    
  }


   
  supprimerArticle(index: number): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '95vw', maxWidth: '400px',
      data: {
        title: 'Confirmer la suppression',
        message: 'Voulez-vous vraiment supprimer cet article de la commande ?',
        confirmLabel: 'Supprimer',
        confirmIcon: '🗑️',
        confirmStyle: 'danger' as const
      }
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.articleSupprime.emit(index);
      }
    });
  }
   
   getArticles(): FormArray {
    return this.parentForm?.get('articles') as FormArray;
  }

  get filteredArticles() {
    const articles = this.getArticles().value;
    if (!this.searchFilter.trim()) {
      return articles;
    }
    
    const filter = this.searchFilter.toLowerCase();
    return articles.filter((article: any) => {
      return (
        article.typeArticle?.toLowerCase().includes(filter) ||
        article.typeConditionnement?.toLowerCase().includes(filter) ||
        article.description?.toLowerCase().includes(filter)
      );
    });
  }

  getArticleData(articles: any, columnNames: string): String {
    return this.sharedUtilsService.obtenirValeurDepuisObjet(articles, columnNames);
  }



  localisationOk() : boolean {
    if (this.parentForm.value['lieuDepartLongitude'] == 0.0 || this.parentForm.value['lieuDepartLongitude'] == undefined
      || this.parentForm.value['lieuDepartLatitude'] == 0.0 || this.parentForm.value['lieuDepartLatitude'] == undefined) {
      this.toastService.erreur("Vous devez indiquer la localisation de l'expéditeur", 'Erreur de saisie');
      return false;
    }

    if (this.parentForm.value['lieuArriveeLongitude'] == 0.0 || this.parentForm.value['lieuArriveeLongitude'] == undefined
      || this.parentForm.value['lieuArriveeLatitude'] == 0.0 || this.parentForm.value['lieuArriveeLatitude'] == undefined) {
      this.toastService.erreur("Vous devez indiquer la localisation du destinataire", 'Erreur de saisie');
      return false;
    }

    this.parentForm.patchValue({ flgTarifParZone: false });
    this.parentForm.patchValue({ trajetId: 0.0 });
    return true;
  }

  trajetOk() : boolean {
    if (this.parentForm.value['trajetId'] == null || this.parentForm.value['trajetId'] == undefined
      || this.parentForm.value['trajetId'] == 0.0) {
      this.toastService.erreur("Vous devez indiquer le trajet", 'Erreur de saisie');
      return false;
    }

    this.parentForm.patchValue({ flgTarifParZone: true });
    this.parentForm.patchValue({ lieuDepartLongitude: 0.0 });
    this.parentForm.patchValue({ lieuDepartLatitude: 0.0 });
    this.parentForm.patchValue({ lieuArriveeLongitude: 0.0 });
    this.parentForm.patchValue({ lieuArriveeLatitude: 0.0 });
    return true;
  }


  
}
